import React from 'react';
import styles from './Header.module.scss';
// import { useThemeContext } from '@context/ThemeProvider/ThemeProvider';
import { getClassName } from '@onsolve/utils.get-class-name';
const Header = ({ namespace }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'header',
        modifiers: {
            blue: true,
        },
        styles,
    });
    return (<header className={rootClass}>
            <h1 className={getChildClass('h1')}>{namespace}</h1>
            <div className={getChildClass('right')}></div>
        </header>);
};
export default Header;
